const cards = [
  {
    title: '《她的私密教学》',
    tag: '韩漫热榜TOP1',
    tagColor: 'primary',
    desc: '高人气韩漫佳作，甜蜜又刺激的师生恋故事，画风精致唯美，每周更新，全网追更人数最多的连载作品之一。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20webtoon%20style%20illustration%20of%20a%20couple%20in%20a%20school%20setting%2C%20soft%20warm%20lighting%20with%20coral%20and%20peach%20tones%2C%20delicate%20anime%20art%20style%2C%20clean%20cream%20background%2C%20emotional%20and%20tender%20atmosphere%2C%20modern%20manhwa%20aesthetic&width=800&height=600&seq=card-comic-01&orientation=landscape',
  },
  {
    title: '《末日生存法则》',
    tag: '日漫经典必看',
    tagColor: 'accent',
    desc: '末日题材日漫巅峰之作，紧张刺激的生存剧情配合精湛分镜，虫虫漫画全集收录，下拉式阅读沉浸感爆棚。',
    image: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20Japanese%20manga%20style%20scene%20with%20a%20lone%20survivor%20in%20ruined%20cityscape%2C%20dramatic%20composition%20with%20warm%20amber%20and%20dark%20tones%2C%20detailed%20line%20art%2C%20cinematic%20atmosphere%2C%20on%20a%20light%20neutral%20background&width=800&height=600&seq=card-comic-02&orientation=landscape',
  },
  {
    title: '《剑道独尊》',
    tag: '国漫热血新番',
    tagColor: 'primary',
    desc: '国产玄幻漫画扛鼎之作，精美的古风画面配合热血剧情，更新稳定质量高，国产漫画爱好者不可错过。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20style%2C%20a%20swordsman%20in%20flowing%20robes%20standing%20on%20a%20mountain%20peak%20at%20sunset%2C%20warm%20golden%20and%20coral%20tones%2C%20ink%20wash%20painting%20influenced%20style%2C%20elegant%20composition%2C%20light%20cream%20backdrop&width=800&height=600&seq=card-comic-03&orientation=landscape',
  },
  {
    title: '《甜蜜的陷阱》',
    tag: '连载人气飙升',
    tagColor: 'accent',
    desc: '都市恋爱题材黑马作品，反转不断的剧情让读者欲罢不能，画风清新甜美，虫虫漫画独家推荐阅读。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20romance%20webtoon%20illustration%2C%20a%20stylish%20couple%20in%20a%20city%20cafe%20setting%2C%20soft%20pastel%20peach%20and%20warm%20beige%20color%20palette%2C%20clean%20Korean%20manhwa%20art%20style%2C%20romantic%20and%20cozy%20vibe%2C%20gentle%20lighting&width=800&height=600&seq=card-comic-04&orientation=landscape',
  },
  {
    title: '《诡异调查员》',
    tag: '悬疑口碑佳作',
    tagColor: 'primary',
    desc: '悬疑推理类人气作品，烧脑剧情配合出人意料的转折，每一话都让人毛骨悚然又欲罢不能，虫虫漫画悬疑区必读。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20style%20illustration%2C%20a%20detective%20in%20a%20dimly%20lit%20room%20with%20clues%20scattered%2C%20warm%20sepia%20and%20dark%20amber%20tones%2C%20atmospheric%20lighting%2C%20detailed%20line%20work%2C%20suspenseful%20mood%2C%20on%20a%20cream%20background&width=800&height=600&seq=card-comic-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500">虫虫漫画编辑团队甄选，口碑与热度兼备的优质作品</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.slice(0, 3).map((card, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer group"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={`虫虫漫画 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`虫虫漫画推荐：${card.title}`}
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{card.title}</h3>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      card.tagColor === 'primary'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    {card.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(3).map((card, i) => (
            <div
              key={i + 3}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer group flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-[200px] aspect-[4/3] sm:aspect-auto overflow-hidden flex-shrink-0">
                <img
                  src={card.image}
                  alt={`虫虫漫画 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`虫虫漫画推荐：${card.title}`}
                />
              </div>
              <div className="p-4 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{card.title}</h3>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      card.tagColor === 'primary'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    {card.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}